import React from 'react';

const NextStepsDefaultIcon = (): JSX.Element => {
  return (
    <svg fill='none' height='32' viewBox='0 0 32 32' width='32' xmlns='http://www.w3.org/2000/svg'>
      <g clipPath='url(#clip0_16161_1000)'>
        <circle cx='16' cy='16' fill='#00946E' r='16' />
        <circle cx='16' cy='16' fill='url(#paint0_linear_16161_1000)' fillOpacity='0.3' r='16' />
        <path
          clipRule='evenodd'
          d='M11.4162 7.68018C9.12916 7.68018 7.27514 9.54209 7.27514 11.8389C7.27514 14.1357 9.12916 15.9976 11.4162 15.9976C13.7032 15.9976 15.5572 14.1357 15.5572 11.8389C15.5572 9.54209 13.7032 7.68018 11.4162 7.68018ZM8.29761 11.8389C8.29761 10.1092 9.69383 8.70702 11.4162 8.70702C13.1385 8.70702 14.5348 10.1092 14.5348 11.8389C14.5348 13.5686 13.1385 14.9707 11.4162 14.9707C9.69383 14.9707 8.29761 13.5686 8.29761 11.8389Z'
          fill='white'
          fillRule='evenodd'
        />
        <path
          d='M5.50294 24.1268C5.50294 20.847 8.15047 18.1882 11.4163 18.1882C14.6822 18.1882 17.3297 20.847 17.3297 24.1268C17.3297 24.4103 17.5586 24.6402 17.8409 24.6402C18.1232 24.6402 18.3521 24.4103 18.3521 24.1268C18.3521 20.2799 15.2469 17.1613 11.4163 17.1613C7.58574 17.1613 4.48047 20.2799 4.48047 24.1268C4.48047 24.4103 4.70937 24.6402 4.99173 24.6402C5.27404 24.6402 5.50294 24.4103 5.50294 24.1268Z'
          fill='white'
        />
        <path
          clipRule='evenodd'
          d='M18.0455 12.1298C18.0455 10.1287 19.6527 8.50167 21.6412 8.50167C23.6298 8.50167 25.2369 10.1287 25.2369 12.1298C25.2369 14.131 23.6298 15.758 21.6412 15.758C19.6527 15.758 18.0455 14.131 18.0455 12.1298ZM21.6412 9.52851C20.2227 9.52851 19.068 10.6905 19.068 12.1298C19.068 13.5692 20.2227 14.7312 21.6412 14.7312C23.0597 14.7312 24.2145 13.5692 24.2145 12.1298C24.2145 10.6905 23.0597 9.52851 21.6412 9.52851Z'
          fill='white'
          fillRule='evenodd'
        />
        <path
          d='M21.6412 17.1736C20.1293 17.1736 18.7783 17.8691 17.8874 18.9599C17.685 18.6767 17.4648 18.4073 17.2282 18.1534C18.3054 16.9231 19.883 16.1467 21.6412 16.1467C24.8892 16.1467 27.5205 18.7961 27.5205 22.0621C27.5205 22.3456 27.2916 22.5755 27.0092 22.5755C26.7269 22.5755 26.498 22.3456 26.498 22.0621C26.498 19.3612 24.3225 17.1736 21.6412 17.1736Z'
          fill='white'
        />
      </g>
      <defs>
        <linearGradient
          gradientUnits='userSpaceOnUse'
          id='paint0_linear_16161_1000'
          x1='16'
          x2='16'
          y1='0'
          y2='32'
        >
          <stop stopColor='white' />
          <stop offset='1' stopColor='white' stopOpacity='0' />
        </linearGradient>
        <clipPath id='clip0_16161_1000'>
          <rect fill='white' height='32' width='32' />
        </clipPath>
      </defs>
    </svg>
  );
};

export default NextStepsDefaultIcon;
